/* eslint-disable */
import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Validation } from '../../shared/services/validation.service';
import { ApplicationActions } from '../../actions/application.actions';
import { MaskingService } from '../../shared/services/masking.service';
import { ModalService } from '../../shared/services/modal.service';
import { NgRedux } from '@angular-redux/store';
import * as _ from 'lodash';
import { debounceTime,distinctUntilChanged } from 'rxjs/operators'

@Component({
  selector: 'md-input',
  template: require('./input.component.html')
})

export class InputComponent {
  @Input() options;
  @Input() showUp;
  @ViewChild('inputElement') ele;
  @Output() valueChange = new EventEmitter();


  constructor(validation: Validation,
    appActions: ApplicationActions,
    masking: MaskingService,
    modal: ModalService,
    router: Router,
    ngRedux: NgRedux) {
    this.validation = validation;
    this.isValid = true;
    this.appActions = appActions;
    this.masking = masking;
    this.ngRedux = ngRedux;
    this.toolTipShow = false;
    this.modal = modal;
    this.router = router;
    this.validateSub = this.validation.validateInput.subscribe(event => this.triggerValidation());

    this.init = false;
  }

  openTheModal() {
    this.modal.setModalData({
      'modalType': 'closable',
      'fukTopRight': 'true',
      'fukTopRightID': 'SSN_Modal_Close',
      'fukTopRightClass': 'modal-top-right-close-btn',
      'modalClass': 'ssn-helper-modal',
      'title': this.options.helperTextModalLink.modal.title,
      'body': this.options.helperTextModalLink.modal.body,
      'buttons': []
    });
    this.router.navigate([{ outlets: { aux: 'modal' } }], { queryParamsHandling: 'preserve' });
  }

  triggerValidation() {
    this.processValidation(this.currentValue);
  }

  ngOnInit() {
    if (this.options.attr.inputClass === undefined) {
      this.options.attr.inputClass = '';
    }
    this.inputClass = this.options.attr.inputClass;
    this.labelClass = this.options?.labelClass?.includes('mid-on-small') ? '' : 'bold-on-small';

    if (this.options.inputPath) {
      const arrayPath = this.options.inputPath.split('.');

      arrayPath.unshift('applicationStore');
      this.arrayPath = arrayPath;

      if (this.options.inputPath.match(/\[\d+\]/) !== -1) {
        this.reduxObservable$ = this.ngRedux.select(state => _.get(state, `applicationStore.${this.options.inputPath}`));
      } else {
        this.reduxObservable$ = this.ngRedux.select(this.arrayPath);
      }

      // Set default value if it exists in schema and state is null
      this.defaultValue = this.options.attr.defaultValue || null;
      this.initialReduxValue = this.appActions.getData(this.options.inputPath);
      if(!this.initialReduxValue && this.defaultValue !== null && this.init === false) {
        this.appActions.setData(this.options.inputPath, this.defaultValue);
      }

      this.reduxSubscription = this.reduxObservable$
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(state => {
        this._preserveSelection();
        this.currentValue = state;

        if (this.currentValue != null || this.init === true) {
          this.processValidation(this.currentValue);
          const payload = {
            id: this.options.attr.id,
            value: this.currentValue,
            isValid: this.isValid
          };

          this.valueChange.emit(payload);
        }

        this.init = true;
        const element = this.ele;
        const data = this.selectData;
        if (this.masking.isMasked(this.options.inputPath)) {
          requestAnimationFrame(() => {
            this._restoreSelection(element, data);
          });
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.validateSub) {
      this.validateSub.unsubscribe();
    }

    if (this.options.inputPath) {
      this.reduxObservable$.unsubscribe();
      this.reduxSubscription.unsubscribe();
    }
  }

  onKeyDown(event) {
    const shiftKey = event.shiftKey ? event.shiftKey: false;
    const ctrlKey = event.ctrlKey ? event.ctrlKey : false;
    const metaKey = event.metaKey ? event.metaKey : false;
    const key = event.keyCode || event.which;

    if (this.masking.isMasked(this.options.inputPath)) {
      return (
        (key >= 37 && key <= 40)
        || key == 8
        || key == 9
        || key == 46
        || key === 13 // Enter key for submit
        || ((key >= 48 && key <= 57) && (shiftKey === false))
        || ctrlKey === true
        || metaKey === true
        || (key >= 96 && key <= 105));
    }
  }

  processValidation(value) {
    const isValidObj = this.validation.validate(this.options.validationType, value || '');
    if (isValidObj !== undefined) {
      this.inputClass = this.inputClass.replace('error', '');
      this.isValid = isValidObj.state;
      if (!this.isValid) {
        this.options.msg = this.options.msg || {};
        this.options.msg.fail = isValidObj.msg;
        this.inputClass += ' error';
      } else {
        this.options.msg = undefined;
      }

      let isValid = this.isValid;
      if (this.showUp === false) {
        isValid = true;
      }
      this.validation.validCheck({
        id: this.options.attr.id,
        isValid: isValid
      });
    }
  }

  formatValue(value, formatType) {
    if (formatType === 'ssn' && value !== undefined) {
      value = value.replace(/^(\d){3}\-(\d){2}\-/, '*****');
    }

    return value;
  }

  onBlur(event) {
    if (this.options.inputPath) {
      this.appActions.setData('blur', this.options.inputPath);
    }
  }

  _preserveSelection() {
    if (this.masking.isMasked(this.options.inputPath)) {
      if (this.ele && this.ele.nativeElement) {
        this.selectData = {
          start: this.ele.nativeElement.selectionStart,
          end: this.ele.nativeElement.selectionEnd
        };
      }
    }
  }

  _restoreSelection(ele, data) {
    ele = ele || this.ele;
    data = data || this.selectData;
    if (this.masking.isMasked(this.options.inputPath)
      && ele && data && ele.nativeElement && data.end) {
      // Need to know if we are 1 off of the last non-numeric character
      const eleValue = ele.nativeElement.value;
      const m = eleValue.match(/(\D)$/);
      if (m && m.index === data.end) {
        data.end += 1;
      }
      ele.nativeElement.setSelectionRange(data.end, data.end);
    }
  }

  onChange(event) {
    this._preserveSelection();
    event = this.masking.maskInput(this.options.inputPath, event);

    if(this.options.inputPath) {
      this.appActions.setData(this.options.inputPath, event);
    } else {
      this.currentValue = event;
      this.processValidation(event);
      const payload = {
        id: this.options.attr.id,
        value: event,
        isValid: this.isValid
      };
      this.valueChange.emit(payload);
    }

    this._restoreSelection();
  }
}
